import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Router} from '@angular/router';
import {SmsModel} from '../../model/smsModel';
import {Observable} from 'rxjs/internal/Observable';
import {smsSearchDTO} from '../dto/smsSearchDTO';
import {AppConfig} from '../common/app.config';

@Injectable({
  providedIn: 'root'
})
export class SmsService {

  private headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});

  constructor(private appConfig: AppConfig, private httpClient: HttpClient, private router: Router) { }

  baseURL: string = this.appConfig.getConfig('BASE_URL');

  getAllRecords(){
    return this.httpClient.get(this.baseURL + 'api/sms/getAll');
  }

  searchRequestDetails(smsSearchParam: smsSearchDTO) {
    return this.httpClient.post(this.baseURL + 'api/sms/searchSMS', smsSearchParam, { headers: this.headers });
  }


  exportAsPDF(smsDto: SmsModel[]): Observable<Object>{
    return this.httpClient.post(this.baseURL + 'api/sms/exportAsPDF', smsDto, {responseType: 'arraybuffer'});
  }


  exportAsExcel(smsDto:SmsModel[]):Observable<object>{
    return this.httpClient.post(this.baseURL + 'api/sms/exportAsExcel', smsDto, {responseType: 'arraybuffer'});

  }

  updateSmsDetails(smsDTO: SmsModel) {
    return this.httpClient.post(this.baseURL + 'api/sms/update' , smsDTO,{responseType: 'text'});
  }

}


